export default function Contact() {
  return (
    <section id="contact" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20banner%20flat%20illustration%20of%20happy%20people%20passing%20a%20note%20and%20photo%20into%20a%20giant%20envelope%20and%20phone%2C%20watermelon%20coral%20red%20and%20fresh%20mint%20green%20on%20warm%20cream%20background%2C%20playful%20rounded%20shapes%2C%20uplifting%20youthful%20energy%2C%20wide%20clean%20composition&width=1600&height=520&seq=cta-melon-x1&orientation=landscape"
            alt="投稿人把材料投入邮箱与手机通道的横幅插画"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-900/70 to-primary-800/40"></div>

          <div className="relative flex flex-col items-start gap-6 px-6 py-12 md:px-14 md:py-16 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h2 className="text-2xl font-bold text-background-50 md:text-4xl">
                手上正握着瓜料？别让它在草稿箱里冷掉
              </h2>
              <p className="mt-3 text-base leading-relaxed text-background-100/90">
                回到上方按「短线索 / 长文 / 证据齐全」对号入座，选一条最快通道，把料递出去。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
              <a
                href="#methods"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-accent-400"
              >
                去选投稿方式
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
              <a
                href="#faq"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-7 py-3.5 text-base font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                还有疑问？看 FAQ
                <i className="ri-question-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}